import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { ResellerReportsPage } from '@/features/reseller/pages/reports'

export const Route = createFileRoute('/_authenticated/reseller/reports')({
  validateSearch: z.object({
    customer_id: z.string().optional(),
  }),
  component: ResellerReportsPage,
})

